export default "__VITE_ASSET__DnLwnptK__"